import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

// Modules
import { ProtocolDroidModule } from '../protocol-droid/protocol-droid.module';
import { SvgIconModule } from './components/svg-icon/svg-icon.module';

// Components
import { BadgeErrorsComponent } from './components/badge-errors/badge-errors.component';
import { BadgeInfosComponent } from './components/badge-infos/badge-infos.component';
import { BadgeComponent } from './components/badge/badge.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ButtonFlashingComponent } from './components/button-flashing/button-flashing.component';
import { ButtonIconComponent } from './components/button-icon/button-icon.component';
import { CaretComponent } from './components/caret/caret.component';
import { HeaderAppDropdownComponent } from './components/header-app-dropdown/header-app-dropdown.component';
import { NavPanelsComponent } from './components/nav-panels/nav-panels.component';
import { NavTabsComponent } from './components/nav-tabs/nav-tabs.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SimpleDropdownComponent } from './components/simple-dropdown/simple-dropdown.component';
import { TinyBotSpinnerComponent } from './components/tiny-bot-spinner/tiny-bot-spinner.component';
import { ToggleStatesComponent } from './components/toggle-states/toggle-states.component';
import { ToggleComponent } from './components/toggle/toggle.component';
// Directives
import { InputAutofocusDirective } from './directives/input-autofocus.directive';
import { InputDisabledFixDirective } from './directives/input-disabled-fix.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    BsDropdownModule,
    ProtocolDroidModule,
    SvgIconModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    TinyBotSpinnerComponent,
    ToggleComponent,
    ButtonFlashingComponent,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    NavTabsComponent,
    NavPanelsComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    CaretComponent,
    SearchBarComponent,
    SimpleDropdownComponent,
    SidebarComponent,
    ToggleStatesComponent,
    ButtonIconComponent,
    BreadcrumbComponent,
    HeaderAppDropdownComponent
  ],
  exports: [
    TinyBotSpinnerComponent,
    ToggleComponent,
    ButtonFlashingComponent,
    RouterModule,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    NavTabsComponent,
    NavPanelsComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    CaretComponent,
    SimpleDropdownComponent,
    SearchBarComponent,
    SidebarComponent,
    ToggleStatesComponent,
    ButtonIconComponent,
    TooltipModule,
    BreadcrumbComponent,
    SvgIconModule,
    HeaderAppDropdownComponent
  ]
})
export class UiElementsModule {}
